import React from 'react';
import CommonUtils from '../../utilities/common-utils';
import { Badge, BadgeProps, MantineColor } from '@good/ui/core';

export type StatusTagStatus =
  | 'PENDING'
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'CONFIRMED'
  | 'INPROGRESS'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'APPROVED'
  | 'READY_FOR_BILLING'
  | 'REQUIRES_APPROVAL'
  | 'BILLED'
  | 'BILLING_FAILED'
  | 'REJECTED'
  | 'ARCHIVED'
  | 'SEND_TO_FINANCE'
  | 'CUSTOMER_CANCELLED'
  | 'CUSTOMER_CANCELLED_WITH_FEE'
  | 'CUSTOMER_CANCELLED_WITHOUT_FEE'
  | 'BUSINESS_CANCELLED'
  | 'SCHEDULED'
  | 'SENT_TO_FINANCE'
  | 'CHECKED_IN'
  | 'CHECKED_OUT'
  | 'NO_SHOW'
  | 'CANCELLED_PAID'
  | 'CANCELLED_UNPAID'
  | 'ON_LEAVE'
  | 'LEAVE_APPROVED'
  | 'UNASSIGNED'
  | 'DECLINED'
  | 'CLAIMED'
  | 'PUBLISHING';

interface StatusTagProps extends Omit<BadgeProps, 'size'> {
  status: StatusTagStatus;
  size: BadgeProps['size'] | 'small';
}

const StatusTag = ({ status, size: sizeProp, ...props }: StatusTagProps) => {
  const statusColors: Record<
    StatusTagStatus,
    {
      color: MantineColor;
      theme: 'dark' | 'light';
    }
  > = {
    PENDING: { color: 'gray', theme: 'dark' },
    ACCEPTED: { color: 'green', theme: 'dark' },
    CANCELLED: { color: 'red', theme: 'light' },
    CONFIRMED: { color: 'ocean', theme: 'dark' },
    INPROGRESS: { color: 'yellow', theme: 'dark' },
    IN_PROGRESS: { color: 'yellow', theme: 'dark' },
    COMPLETED: { color: 'lilac', theme: 'light' },
    APPROVED: { color: 'orange', theme: 'dark' },
    READY_FOR_BILLING: { color: 'dark', theme: 'dark' },
    BILLED: { color: 'lime', theme: 'dark' },
    BILLING_FAILED: { color: 'red', theme: 'dark' },
    REJECTED: { color: 'red', theme: 'dark' },
    CUSTOMER_CANCELLED: { color: 'red', theme: 'light' },
    CUSTOMER_CANCELLED_WITH_FEE: { color: 'red', theme: 'light' },
    CUSTOMER_CANCELLED_WITHOUT_FEE: { color: 'red', theme: 'light' },
    BUSINESS_CANCELLED: { color: 'red', theme: 'light' },
    REQUIRES_APPROVAL: { color: 'turquoise', theme: 'dark' },
    ARCHIVED: { color: 'red', theme: 'light' },
    SCHEDULED: { color: 'green', theme: 'dark' },
    SEND_TO_FINANCE: { color: 'ocean', theme: 'light' },
    SENT_TO_FINANCE: { color: 'ocean', theme: 'light' },
    CHECKED_IN: { color: 'lavender', theme: 'dark' },
    CHECKED_OUT: { color: 'green', theme: 'light' },
    NO_SHOW: { color: 'red', theme: 'light' },
    CANCELLED_PAID: { color: 'red', theme: 'light' },
    CANCELLED_UNPAID: { color: 'red', theme: 'light' },
    ON_LEAVE: { color: 'gray', theme: 'dark' },
    LEAVE_APPROVED: { color: 'ocean', theme: 'light' },
    UNASSIGNED: { color: 'orange', theme: 'light' },
    DECLINED: { color: 'red', theme: 'light' },
    CLAIMED: { color: 'violet', theme: 'light' },
    PUBLISHING: { color: 'turquoise', theme: 'dark' },
  };
  const color = statusColors[status] ? statusColors[status].color : 'blue';
  const theme = statusColors[status] ? statusColors[status].theme : 'dark';
  let size = sizeProp;
  if (sizeProp === 'small') {
    size = 'md';
  }

  return (
    <Badge variant={theme === 'dark' ? 'filled' : 'outline'} color={color} size={size} {...props}>
      {CommonUtils.formatStatusString(status)}
    </Badge>
  );
};

export default StatusTag;
